<script>
const sidebarMenu = [
  { path: '/account', icon: 'fa fa-users', title: 'ui.member_management', pages: [config.accessRoles.account, config.accessRoles.editAccount, config.accessRoles.subAccount, config.accessRoles.adminAccount, config.accessRoles.socialAccount],
    children: [
      { path: '/adminList', title: 'ui.admin_list', pages: [config.accessRoles.adminAccount] },
      { path: '/newAccount', title: 'ui.new_account', pages: [config.accessRoles.editAccount] },
      { path: '/accountList', title: 'ui.account_list', pages: [config.accessRoles.account] },
      { path: '/subAccount', title: 'ui.sub_account', pages: [config.accessRoles.subAccount] },
      { path: '/socialAccount', title: 'ui.social_account', pages: [config.accessRoles.socialAccount] },
    ]
  },
  { path: '/bank', icon: 'fas fa-landmark', title: 'ui.bank', pages: [config.accessRoles.bank],
    children: [
      { path: '/bankAccount', title: 'ui.bank_account', pages: [config.accessRoles.bank] },
    ]
  },
  { path: '/promotion', icon: 'fa fa-bullhorn', title: 'ui.promotion', pages: [config.accessRoles.promotion],
    children: [
      { path: '/promotionList', title: 'ui.promotion_list', pages: [config.accessRoles.promotion] },
    ]
  },
  { path: '/ticket', icon: 'fa fa-list', title: 'ui.ticket', pages: [config.accessRoles.ticket],
    children: [
      { path: '/ticketList', title: 'ui.ticket_list', pages: [config.accessRoles.ticket] },
    ]
  },
  { path: '/report', icon: 'fa fa-list-alt', title: 'ui.report', pages: [config.accessRoles.report],
    children: [
      { path: '/dailyWinlose', title: 'ui.daily_winlose_details', pages: [config.accessRoles.report] },
      { path: '/dailyWinloseAIO', title: 'ui.daily_winlose_aio', pages: [config.accessRoles.report] },
      { path: '/dailyWinloseByPlatformDetail', title: 'ui.daily_winlose_platform', pages: [config.accessRoles.report] },
      { path: '/gameResultDetail', title: 'ui.game_result', pages: [config.accessRoles.report] },
      { path: '/dailyStatementMember', title: 'ui.daily_statement', pages: [config.accessRoles.report] },
      { path: '/settlementHistory', title: 'ui.transfer_history', pages: [config.accessRoles.report] },
      { path: '/settlementHistoryDownline', title: 'ui.transfer_history_downline', pages: [config.accessRoles.settlementHistoryDownline] }
    ]
  },
  { path: '/settlement', icon: 'fa fa-calculator', title: 'ui.transfer', pages: [config.accessRoles.settlement],
    children: [
      { path: '/settlementList', title: 'ui.transfer_list', pages: [config.accessRoles.settlement] }
    ]
  },
  { path: '/logs', icon: 'fa fa-hdd', title: 'ui.logs', pages: [config.accessRoles.log],
    children: [
      { path: '/accessLog', title: 'ui.access_log', pages: [config.accessRoles.log] },
      { path: '/accountLog', title: 'ui.account_log', pages: [config.accessRoles.log] },
      { path: '/memberLog', title: 'ui.member_log', pages: [config.accessRoles.log] },
      { path: '/positionTakingLog', title: 'ui.position_taking_log', pages: [config.accessRoles.log] },
      { path: '/commissionLog', title: 'ui.commission_log', pages: [config.accessRoles.log] },
      { path: '/betLimitLog', title: 'ui.bet_limit_log', pages: [config.accessRoles.log] },
      { path: '/walletLog', title: 'ui.wallet_log', pages: [config.accessRoles.walletLog] },
      { path: '/settlementScheduleLog', title: 'ui.settlement_schedule_log', pages: [config.accessRoles.settlementScheduleLog] },
      { path: '/promotionLog', title: 'ui.promotion_log', pages: [config.accessRoles.log] },
      { path: '/providerLog', title: 'ui.provider_log', pages: [config.accessRoles.providerLog] },
    ]
  }

]
import config from "@/config";
import store from "@/store";
export default sidebarMenu;
</script>
